export const text = {
  center: { "text-align": "center" },
  right: { "text-align": "right" },
  left: { "text-align": "left" },
};

export const font = {
  s10: { "font-size": "10px" },
  s12: { "font-size": "12px" },
  s14: { "font-size": "14px" },
  s18: { "font-size": "18px" },
  s30: { "font-size": "30px" },
  bold: { "font-weight": "bold" },
  underline: { "text-decoration": "underline" },
  family: { "font-family": '"Arial" !important' },
};

export const width = {
  w16: { width: "16.6%" },
  w25: { width: "25%" },
};

export const page = {
  header: { ...font.s14, ...text.center },
  pageCount: { ...font.s12, ...text.right },
};

const _table = {
  table: {
    width: "100%",
    "margin-top": "15px",
    "border-collapse": "collapse",
  },
  header: {
    ...font.s12,
    "border-top": "1px solid black",
    "border-bottom": "1px solid black",
    padding: "5px 0",
  },
  data: { ...font.s10 },
};
_table.headerLeft = { ..._table.header, ...text.left };
_table.headerCenter = { ..._table.header, ...text.center };
_table.headerRight = { ..._table.header, ...text.right };
_table.dataLeft = { ..._table.data, ...text.left };
_table.dataCenter = { ..._table.data, ...text.center };
_table.dataRight = { ..._table.data, ...text.right };
_table.subheader = { ...font.s12, ...font.bold, "padding-top": "5px" };
_table.subheaderLeft = { ..._table.subheader, ...text.left };
_table.subheaderCenter = { ..._table.subheader, ...text.center };
_table.subheaderRight = { ..._table.subheader, ...text.right };

export const table = { ..._table };
